<template>
  <va-card>
    <div class="logo-container">
      <img src="../../assets/logo.png" alt="Rewarding Dog Training logo" />
    </div>
    <span class="company-description">
      Force free, positive reinforcement training that is rewarding for humans and dogs
    </span>
    <span class="services-offered">
      Looking to train your canine friend on helping with any of the following?
      <ul>
        <li>separation anxiety</li>
        <li>basic manners</li>
        <li>calmness</li>
        <li>“go to place"</li>
        <li>decreasing jumping</li>
        <li>leash reactivity</li>
        <li>resource guarding</li>
        <li>muzzle training</li>
        <li>trick training</li>
        <li>something else?</li>
      </ul>
    </span>
    <span class="services-offered">
      <b>
        We are here to help!
      </b>
    </span>
    <span class="services-offered">
      Currently offering in person training in Boulder, Erie, Superior, Louisville, and Lafayette, Colorado and virtual training options.
    </span>
  </va-card>
</template>

<script>

export default {
  name: 'description-card',
}
</script>

<style scoped lang="scss">
  .logo-container {
    display: flex;
    justify-content: center;
    height: 14rem;
    margin-bottom: 24px;

    img {
      height: 100%;
      width: auto;
    }
  }

  .company-description {
    text-align: center;
    font-size: 1.6rem;
    line-height: 1.2;
    font-weight: 500;
  }

  .services-offered {
    margin-top: 1.6rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: left;
  }

  ul {
    margin-top: 1rem;
    margin-left: 2rem;
    margin-bottom: 1rem;

    li {
      list-style: circle;

      .italic {
        margin-top: 0;
        font-style: italic;
      }
    }
  }
</style>
